import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function Impersonate() {
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token');
    const name = params.get('name');
    if (token) {
      localStorage.setItem('admin_token', token);
      localStorage.setItem('admin_name', name || 'System Admin');
      localStorage.setItem('admin_role', 'admin');
      navigate('/dashboard');
    } else {
      navigate('/login');
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#0f0f1a',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: '#ffffff',
      fontSize: '18px',
    }}>
      Logging in...
    </div>
  );
}

export default Impersonate;